import { MEDIA_NOW_PREFIX, MEDIA_NOW_SUFFIX } from './videoUrlComm';

export const PRIMERA_VIDEO_URL = Object.freeze({
  FACTORY_UNBOX_STEP1:
    MEDIA_NOW_PREFIX + 'LNPNNLDGHJ&ek=A529hlM' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP2:
    MEDIA_NOW_PREFIX + 'RLLPQLGFKD&ek=XZaGkoaB' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP3:
    MEDIA_NOW_PREFIX + 'SKRJJLDDGH&ek=TOkSEzik' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP4:
    MEDIA_NOW_PREFIX + 'NQNRPPJJLD&ek=3vyFTupQ' + MEDIA_NOW_SUFFIX,
  FACTORY_CABLE_STEP1:
    MEDIA_NOW_PREFIX + 'QRPLSNDLDI&ek=T40WkBuF' + MEDIA_NOW_SUFFIX,
  FACTORY_CABLE_STEP2:
    MEDIA_NOW_PREFIX + 'SSSOQKLDFL&ek=hOWfq03F' + MEDIA_NOW_SUFFIX,
  FACTORY_CABLE_STEP4:
    MEDIA_NOW_PREFIX + 'KJROSQHKDL&ek=gCLDM6Q0' + MEDIA_NOW_SUFFIX,

  POWERUPANDINIT_POWER:
    MEDIA_NOW_PREFIX + 'MRQRKLLIHJ&ek=gOASV5xL' + MEDIA_NOW_SUFFIX,
  POWERUPANDINIT_INIT:
    MEDIA_NOW_PREFIX + 'OLMSOPMILH&ek=nnckxQur' + MEDIA_NOW_SUFFIX,

  FIELD_RACKARRAY_STEP1:
    MEDIA_NOW_PREFIX + 'RLNMKLHDLM&ek=BS39RUWs' + MEDIA_NOW_SUFFIX,
  FIELD_RACKARRAY_STEP2:
    MEDIA_NOW_PREFIX + 'NKKNKQGJIJ&ek=HU3ElaAD' + MEDIA_NOW_SUFFIX,
  FIELD_RACKARRAY_STEP3:
    MEDIA_NOW_PREFIX + 'NKKKJPHJJF&ek=i1TZYee8' + MEDIA_NOW_SUFFIX,
  FIELD_RACKARRAY_STEP4:
    MEDIA_NOW_PREFIX + 'QJOJKRGHMJ&ek=vYJixuE2' + MEDIA_NOW_SUFFIX,

  key: MEDIA_NOW_PREFIX + 'LNPNNLDGHJ&ek=A529hlM' + MEDIA_NOW_SUFFIX,
  key2: MEDIA_NOW_PREFIX + 'LNPNNLDGHJ&ek=A529hlM' + MEDIA_NOW_SUFFIX,
  // FIELD_RACKARRAY_STEP1
  // FACTORY_UNBOX_STEP1: '//media.now.hpe.com/EmbeddedPlayer.ashx?key=LNPNNLDGHJ&ek=A529hlM3&pb=0&play=1&width=100%&height=100%&xdomain=1&targetdivid=playerDiv',
});
